import type { FC } from 'react';

/**
 * `GTM` block for the CMS-agnostic lane, serving **both** providers. Renders nothing, deliberately.
 *
 * It appears in the migrated chrome (`pageChrome` documents carry it alongside `MainNavigation`/
 * `Footer`) because Sitecore modelled tag management as a page rendering. It has no visual output, and
 * this lane already sets up tracking one level up: `CmsRouteContainer` wraps every page in
 * `CmsGTMProvider` and `PageViewTracker`.
 *
 * Registered rather than left out so it resolves to nothing instead of the dev-only
 * `[missing component: GTM]` marker, which would otherwise sit in the header of every article page.
 * The production rendering is `@apps/gtm-shared-multilabel`, tagged `app:next` and outside
 * `lib:cms-components`'s module boundary (`nx.json`), so it cannot be reused here.
 */
const GTM: FC = () => null;

export default GTM;
